// Application level constants
export const APP_NAME = import.meta.env.VITE_APP_NAME || "Shepherd's Finance";
export const APP_VERSION = import.meta.env.VITE_APP_VERSION || '1.0.0';

export const LOCAL_STORAGE_KEYS = {
  TOKEN: 'auth_token',
  REFRESH_TOKEN: 'refresh_token',
  USER: 'user_data',
  THEME: 'app_theme',
} as const;

export const SESSION_STORAGE_KEYS = {
  REDIRECT_URL: 'redirect_url',
} as const;

export const PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_PAGE_SIZE: 10,
  PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
} as const;

export const DATE_FORMATS = {
  DISPLAY: 'MMM dd, yyyy',
  DISPLAY_WITH_TIME: 'MMM dd, yyyy HH:mm',
  API: "yyyy-MM-dd'T'HH:mm:ss",
} as const;
